export const NUMBER_OF_MATURE_INDIVIDUALS_ID = 1
export const AREA_OF_OCCUPANCY_ID = 2
export const EXTENT_OF_SUITABLE_HABITAT_ID = 3
export const RANGE_ID = 4
export const NUMBER_OF_LOCALITIES_ID = 5
export const DISTINCT_GENETIC_DIVERSITY_ID = 6

export const specieAssessmentParameterType = [
  { id: NUMBER_OF_MATURE_INDIVIDUALS_ID, name: 'number of mature individuals', label: '(i)' },
  { id: AREA_OF_OCCUPANCY_ID, name: 'area of occupancy', label: '(ii)' },
  { id: EXTENT_OF_SUITABLE_HABITAT_ID, name: 'extent of suitable habitat', label: '(iii)' },
  { id: RANGE_ID, name: 'range', label: '(iv)' },
  { id: NUMBER_OF_LOCALITIES_ID, name: 'number of localities', label: '(v)' },
  { id: DISTINCT_GENETIC_DIVERSITY_ID, name: 'distinct genetic diversity', label: '(vi)' }
]
